<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" md="4">
        <v-card class="pa-2">
          <v-card-title>
            <h4>Détail de la demande</h4>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <b>Cabinet: </b>
            {{ this.$store.getters["Auth/get_selected_demandequitus"].nomCabinet }}
            <v-spacer class="my-1"></v-spacer>
            <b>Nom du chargé: </b>
            {{ this.$store.getters["Auth/get_selected_demandequitus"].nomPersonne }}
            <v-spacer class="my-1"></v-spacer>
            <b>E-mail: </b>
            {{ this.$store.getters["Auth/get_selected_demandequitus"].emailContact }}
            <v-spacer class="my-1"></v-spacer>
            <b>Date Demande: </b>
            {{ this.$store.getters["Auth/get_selected_demandequitus"].dateDemande }}
            <v-spacer class="my-1"></v-spacer>
            <b>Status Demande: </b>
            {{ this.$store.getters["Auth/get_selected_demandequitus"].status }}
            <v-spacer class="my-1"></v-spacer>
          </v-card-text>
        </v-card>

        <v-card class="pa-2 mt-2">
          <v-card-title>
            <h4>Voir le justificatif</h4>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-row>
              <v-list-item class="block text-truncate">
                <v-list-item-content>
                  <v-list-item-title class="primary--text text-truncate font-weight-bold">
                    {{ this.$store.getters["Auth/get_selected_demandequitus"].fileNameJustificative }}
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn small icon @click="ViewJustificatif()">
                    <v-icon color="grey lighten-1">mdi-eye</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-row>
          </v-card-text>
        </v-card>



        <v-card class="mt-2" v-if="this.$store.getters['Auth/get_selected_demandequitus'].status != 'Délivrée'">
          <v-card-title id="v-step-0">
            <h4>Répondre à la demande de quitus</h4>
          </v-card-title>
          <v-card-text>
            <!-- Menu déroulant pour le choix "Valider" ou "Non Valider" -->
            <v-select v-model="isValidChoice" :items="['Je valide la demande', 'Demande non Validée']"
              label="Choix de validation"></v-select>

            <!-- Champs qui s'affichent lorsque "Valider" est choisi -->
            <div v-if="isValidChoice === 'Je valide la demande'">
              <v-file-input v-model="quitus.file_response" multiple label="Joindre le quitus" truncate-length="15">
                <template v-slot:selection="{ text }">
                  <v-chip small label color="primary">{{ text }}</v-chip>
                </template>
              </v-file-input>
            </div>

            <!-- Champs qui s'affichent lorsque "Non Valider" est choisi -->
            <div v-if="isValidChoice === 'Demande non Validée'">
              <v-file-input v-model="quitus.file_response" multiple label="Joindre la lettre de rejet"
                truncate-length="15">
                <template v-slot:selection="{ text }">
                  <v-chip small label color="primary">{{ text }}</v-chip>
                </template>
              </v-file-input>
            </div>
            <v-btn small color="primary" class="ma-2 white--text" block
              @click="submitResponse">
              <v-icon class="mr-2" dark>mdi-cloud-upload</v-icon>Envoyer
            </v-btn>
          </v-card-text>
        </v-card>

      </v-col>
      <v-col cols="12" md="8">
        <v-card>
          <v-card-title>
            <h4>Aperçu de la demande</h4>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text style="height:62em !important;overflow:hidden">
            <VueDocPreview style="height:100%" v-if="this.$store.getters['Auth/get_selected_demandequitus'].extensionDemande == 'doc' ||
              this.$store.getters['Auth/get_selected_demandequitus'].extensionDemande == 'docx' ||
              this.$store.getters['Auth/get_selected_demandequitus'].extensionDemande == 'xls' ||
              this.$store.getters['Auth/get_selected_demandequitus'].extensionDemande == 'xlsx' ||
              this.$store.getters['Auth/get_selected_demandequitus'].extensionDemande == 'XLS' ||
              this.$store.getters['Auth/get_selected_demandequitus'].extensionDemande == 'XLSX'
              " :value="this.$store.getters['Auth/get_selected_demandequitus'].fileLinkDemande" type="office" />

            <vue-friendly-iframe v-if="this.$store.getters['Auth/get_selected_demandequitus'].extensionDemande == 'pdf'"
              :src="this.$store.getters['Auth/get_selected_demandequitus'].fileLinkDemande + '#toolbar=0'
              " frameborder="0" loading="lazy"></vue-friendly-iframe>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row justify="center" v-if="dialog">
      <v-dialog eager v-model="dialog" width="900px">
        <v-card>
          <v-card-title>
            <h4>{{ this.$store.getters["Auth/get_selected_demandequitus"].fileNameJustificative }}</h4>
          </v-card-title>
          <v-divider></v-divider>
          <VueDocPreview v-if="this.$store.getters['Auth/get_selected_demandequitus'].extensionJustificative == 'doc' ||
              this.$store.getters['Auth/get_selected_demandequitus'].extensionJustificative == 'docx' ||
              this.$store.getters['Auth/get_selected_demandequitus'].extensionJustificative == 'xls' ||
              this.$store.getters['Auth/get_selected_demandequitus'].extensionJustificative == 'xlsx' ||
              this.$store.getters['Auth/get_selected_demandequitus'].extensionJustificative == 'XLS' ||
              this.$store.getters['Auth/get_selected_demandequitus'].extensionJustificative == 'XLSX'
              " :value="this.$store.getters['Auth/get_selected_demandequitus'].fileLinkJustificative" type="office" />
          <v-card-text>
            <v-row>
              <vue-friendly-iframe
                v-if="this.$store.getters['Auth/get_selected_demandequitus'].extensionJustificative == 'pdf'"
                allow="true" :src="this.$store.getters['Auth/get_selected_demandequitus'].fileLinkJustificative"
                class="w-62em" frameborder="0" loading="lazy"></vue-friendly-iframe>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
import VueDocPreview from "vue-doc-preview";

export default {
  components: {
    VueDocPreview
  },
  props: {
    id: {
      type: Number,
      required: true
    }
  },
  data: () => ({
    profile: 0,
    dialog: false,
    quitus: {
      file_response: [],
    },
    InitLink: "",
    isLoading: false,
    isValidChoice: null,
  }),
  created() {
    this.$store.dispatch("Auth/loadDemandeQuitusById", this.id);
    let Virt = [];
    Virt = JSON.parse(localStorage.getItem("userData"));
    this.profile = Virt.profile.status;
  },
  methods: {
    getInit() {
      this.InitLink = this.$store.getters["Auth/get_selected_demandequitus"].file_link;
      console.log("INFOS", InitLink);
    },

    ViewJustificatif() {
      // Récupérez l'URL du justificatif à partir du store
      const justificatifUrl = this.$store.getters["Auth/get_selected_demandequitus"].fileLinkJustificatif;

      // Stockez l'URL du justificatif dans une variable pour l'afficher dans la modale
      this.justificatifUrl = justificatifUrl;

      // Affichez la modale pour visualiser le justificatif
      this.dialog = true;
    },
    downloadFiche() {
      const data = new FormData();
      data.append("id", this.id);
      this.$store.dispatch("Auth/downloadFiche", data);
    },
    async submitResponse() {
      this.isLoading = true;
      try {
        if (this.isValidChoice === 'Je valide la demande') {
          // Call the validatePPM API here
          const formData = new FormData();
          formData.append('quitus_id', this.id);
          formData.append('status', "Délivrée");
          formData.append('file_response', this.quitus.file_response[0]);
          const response = await this.$store.dispatch("Auth/respondQuitus", formData);
          console.log(response); 
        } else if (this.isValidChoice === 'Demande non Validée') {
          const formData = new FormData();
          formData.append('quitus_id', this.id);
          formData.append('status', "Rejetée");
          formData.append('file_response', this.quitus.file_response[0]);
          const response = await this.$store.dispatch("Auth/respondQuitus", formData); 
          this.isValidChoice = "";
          this.quitus.file_response = null;
          console.log(response);
        }
         // Réinitialisation après l'envoi de la réponse
        this.isValidChoice = null;
        this.quitus.file_response = [];
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  }
};
</script>
<style>
.w-62em {
  height: 62em !important;
  width: 100% !important;
}

.v-card__text {
  width: 100% !important;
}

.vue-friendly-iframe iframe {
  width: 100% !important;
  height: 62em !important;
}
</style>